import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface AgreementFormData {
    title: string,
    body: string,
    notice: string,
    required: boolean;
}
@Injectable({
  providedIn: 'root' 
})
export class AgreementFormDataService {
  private formDataSubject = new BehaviorSubject<AgreementFormData | null>(null);
  formData$ = this.formDataSubject.asObservable();

  setFormData(data: AgreementFormData | null): void {
    this.formDataSubject.next(data);
  }

  clearFormData() {
    this.formDataSubject.next(null);
  }
}
